export class MapLinkInfo {
  name: string = null;
  count = 0;

  constructor(element: any) {
    if (element) {
      this.name = element.name;
      this.count = element.count;
    }
  }
}
